import React from 'react'
import { motion } from 'framer-motion'
import { Star, Headphones, Mic, Music, ThumbsUp, MessageCircle } from 'lucide-react'
import { Link } from 'react-router-dom'

const ReviewsPage = () => {
  const tabs = [
    { id: 'gear', name: 'Gear Reviews', icon: Headphones, color: 'from-le-accent to-purple-600' },
    { id: 'artists', name: 'Artist Spotlights', icon: Music, color: 'from-le-accent-2 to-blue-600' },
    { id: 'venues', name: 'Venue Reviews', icon: Mic, color: 'from-le-amber to-orange-600' },
  ]
  const [active, setActive] = React.useState('gear')

  const reviews = Array.from({ length: 9 }).map((_, i) => ({
    id: i + 1,
    title: i % 3 === 0 ? 'Shure SM58 - The Workhorse Mic' : i % 3 === 1 ? 'The Wave - Venue Spotlight' : 'Thunder Road at Lava Tonic',
    category: i % 3 === 0 ? 'Gear' : i % 3 === 1 ? 'Venue' : 'Live',
    rating: 4.5 + ((i % 5) * 0.1),
    likes: 100 + i * 3,
    comments: 20 + i,
    readTime: `${3 + (i % 4)} min`,
    image:
      i % 3 === 0
        ? 'https://images.pexels.com/photos/164938/pexels-photo-164938.jpeg?auto=compress&cs=tinysrgb&w=600'
        : i % 3 === 1
        ? 'https://images.pexels.com/photos/1540406/pexels-photo-1540406.jpeg?auto=compress&cs=tinysrgb&w=600'
        : 'https://images.pexels.com/photos/1105666/pexels-photo-1105666.jpeg?auto=compress&cs=tinysrgb&w=600',
  }))

  return (
    <div className="pt-16 lg:pt-20 min-h-screen">
      <section className="section-padding py-16">
        <div className="container-max">
          <motion.div className="text-center mb-10" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
            <h1 className="text-5xl font-display font-bold text-white mb-4">Reviews &
              <span className="text-gradient block">Spotlights</span>
            </h1>
            <p className="text-xl text-white/70 max-w-3xl mx-auto">Expert takes and community reviews on gear, artists, and venues.</p>
          </motion.div>

          <div className="flex gap-2 overflow-x-auto pb-2 mb-8">
            {tabs.map((t) => {
              const Icon = t.icon
              const activeTab = active === t.id
              return (
                <button key={t.id} onClick={() => setActive(t.id)} className={`flex items-center gap-3 px-6 py-3 rounded-xl font-medium whitespace-nowrap transition-all duration-300 ${activeTab ? 'bg-gradient-to-r ' + t.color + ' text-white shadow-lg' : 'glass-card text-white/70 hover:text-white hover:bg-white/10'}`}>
                  <Icon size={18} />
                  <span>{t.name}</span>
                </button>
              )
            })}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {reviews.map((r, index) => (
              <motion.article key={r.id} className="glass-card overflow-hidden card-hover group" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: index * 0.05 }} viewport={{ once: true }}>
                <Link to={`/reviews/${r.id}`} className="block">
                  <div className="relative h-48 overflow-hidden">
                    <img src={r.image} alt={r.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
                    <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between text-white text-sm">
                      <span className="bg-black/40 backdrop-blur-sm px-2 py-1 rounded-full">{r.category}</span>
                      <div className="flex items-center gap-1"><Star size={14} className="text-yellow-400 fill-current" /><span>{r.rating.toFixed(1)}</span></div>
                    </div>
                  </div>
                  <div className="p-6">
                    <h3 className="font-display font-semibold text-xl text-white mb-2 group-hover:text-le-accent transition-colors duration-300 leading-tight">{r.title}</h3>
                    <div className="flex items-center justify-between text-sm text-white/60 mb-4">
                      <div className="flex items-center gap-4">
                        <div className="flex items-center gap-1"><ThumbsUp size={14} /><span>{r.likes}</span></div>
                        <div className="flex items-center gap-1"><MessageCircle size={14} /><span>{r.comments}</span></div>
                      </div>
                      <span>{r.readTime} read</span>
                    </div>
                    <div className="w-full btn-secondary text-sm py-2 text-center">Read Full Review</div>
                  </div>
                </Link>
              </motion.article>
            ))}
          </div>
        </div>
      </section>
    </div>
  )
}

export default ReviewsPage

